
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexiNtA_znKj_zn_45wsEgsmLpyYSVS7XVZ24_KIDRjqK_10Meta } from "/app/src/pages/index.vue?macro=true";
import { default as loginat_45I4W6dhaKeU4e7R3nRygvy7k1_45w8CiYRML3dJJNP8Meta } from "/app/src/pages/login.vue?macro=true";
import { default as indexaIvZKiUinKzPWcX_451DuzdmUcwdr_45KqxLB4z_452JO2d_oMeta } from "/app/src/pages/admin/index.vue?macro=true";
import { default as dashboardWSiUgwBbd57Ft0NhiueL6uLJeeWN0CENmS19eCuZN38Meta } from "/app/src/pages/admin/dashboard.vue?macro=true";
import { default as indexp85RvdjINrkCbX5jD3SBUH21T_OJwmutMagPAwQnFBkMeta } from "/app/src/pages/dashboard/index.vue?macro=true";
import { default as legacy_45qr_45redirect6NjTOE03jWT0fM1DKuxxu22qpb54_xjLTi8Dq9Lta1IMeta } from "/app/src/pages/legacy-qr-redirect.vue?macro=true";
import { default as index30Eppd_45ZpgTHqPUWsbiFPHqlMlK6GAZ3Cx1dudKBMwYMeta } from "/app/src/pages/dashboard/protocol/index.vue?macro=true";
import { default as _91id_93eJvtN_45J5Nf41wO3rFOzqXzK5UkOyYMP42izVj1s5oMsMeta } from "/app/src/pages/admin/company/[pageType]/[id].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexiNtA_znKj_zn_45wsEgsmLpyYSVS7XVZ24_KIDRjqK_10Meta || {},
    component: () => import("/app/src/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginat_45I4W6dhaKeU4e7R3nRygvy7k1_45w8CiYRML3dJJNP8Meta || {},
    component: () => import("/app/src/pages/login.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexaIvZKiUinKzPWcX_451DuzdmUcwdr_45KqxLB4z_452JO2d_oMeta || {},
    component: () => import("/app/src/pages/admin/index.vue")
  },
  {
    name: "admin-dashboard",
    path: "/admin/dashboard",
    component: () => import("/app/src/pages/admin/dashboard.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/app/src/pages/dashboard/index.vue")
  },
  {
    name: "legacy-qr-redirect",
    path: "/legacy-qr-redirect",
    meta: legacy_45qr_45redirect6NjTOE03jWT0fM1DKuxxu22qpb54_xjLTi8Dq9Lta1IMeta || {},
    component: () => import("/app/src/pages/legacy-qr-redirect.vue")
  },
  {
    name: "dashboard-protocol",
    path: "/dashboard/protocol",
    component: () => import("/app/src/pages/dashboard/protocol/index.vue")
  },
  {
    name: "admin-company-pageType-id",
    path: "/admin/company/:pageType()/:id()",
    component: () => import("/app/src/pages/admin/company/[pageType]/[id].vue")
  },
  {
    name: indexp85RvdjINrkCbX5jD3SBUH21T_OJwmutMagPAwQnFBkMeta?.name,
    path: "/dashboard/machine/:id/folder/:uuid",
    meta: {"auth":false},
    component: () => import("/app/src/pages/dashboard/index.vue")
  },
  {
    name: index30Eppd_45ZpgTHqPUWsbiFPHqlMlK6GAZ3Cx1dudKBMwYMeta?.name,
    path: "/dashboard/machine/:id/folder/:uuid/protocol",
    meta: {"auth":false},
    component: () => import("/app/src/pages/dashboard/protocol/index.vue")
  },
  {
    name: legacy_45qr_45redirect6NjTOE03jWT0fM1DKuxxu22qpb54_xjLTi8Dq9Lta1IMeta?.name,
    path: "/s/:token",
    meta: {"auth":false},
    component: () => import("/app/src/pages/legacy-qr-redirect.vue")
  },
  {
    name: legacy_45qr_45redirect6NjTOE03jWT0fM1DKuxxu22qpb54_xjLTi8Dq9Lta1IMeta?.name,
    path: "/index.php/s/:token",
    meta: {"auth":false},
    component: () => import("/app/src/pages/legacy-qr-redirect.vue")
  },
  {
    name: legacy_45qr_45redirect6NjTOE03jWT0fM1DKuxxu22qpb54_xjLTi8Dq9Lta1IMeta?.name,
    path: "/docs/:token",
    meta: {"auth":false},
    component: () => import("/app/src/pages/legacy-qr-redirect.vue")
  }
]